module.exports = __webpack_public_path__ + "static/img/map.b326f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map.png
// module id = /PMo
// module chunks = 10